import { PaginateQuery } from "core/resources/types/shared";

export interface ManutencaoDto {
  id: string;
  nome: string;
  responsavelTecnico: {
    id: string;
    nome: string;
  };
  equipamentos: {
    id: string;
    nome: string;
  }[];
  status: {
    id: StatusManutencaoEnum;
    nome: string;
  };
  periodicidade: string;
  dataPrevistaInicial: string;
  dataRealizacao: string | null;
  data: string;
  tipoIntervaloRepeticaoId: string | null;
  intervaloRepeticao: number | null;
  tenant?: {
    id: string;
    nome: string;
  } | null;
}

export interface ManutencaoDetalhe
  extends Omit<
    ManutencaoDto,
    "status" | "periodicidade" | "dataRealizacao" | "data"
  > {
  observacao: string | null;
  codigo: string;
  arquivos: {
    id: string;
    nome: string;
    referencia: string;
    mimetype: string;
  }[];
}

export interface DashboardManutencao {
  concluidas: number;
  equipamentos: number;
  emAtraso: number;
  pendentes: number;
  proximas?: {
    id: string;
    data: string;
    equipamentos: string;
    planoManutencao: string;
    tenant?: {
      id: string;
      nome: string;
    } | null;
  }[];
}

export type CalendarioManutencaoEvent = ManutencaoDto & {
  backgroundColor?: string;
  title: string;
  start: string;
  end?: string;
};

export interface ManutencaoForm {
  id?: string;
  nome: string;
  responsavelTecnicoId?: string;
  responsavelTecnicoNome?: string;
  data: string;
  tipoIntervaloRepeticaoId: string;
  intervaloRepeticao: number;
  observacao: string;
  equipamentosIds: (string | undefined)[];
  files?: (
    | File
    | {
        name: string;
        referencia: string;
        mimetype: string;
        id: string;
      }
  )[];
  tipoRecorrencia?: "recorrente" | "unica";
  oldFilesIds: string;
  recorrencia: boolean;
  anexarArquivos: boolean;

  codigo: string;
  arquivos: {
    nome: string;
    referencia: string;
    mimetype: string;
    id: string;
  }[];
}

export interface RealizarManutencao {
  id: string;
  data: string;
  dataManutencao: string;
  statusManutencaoId: StatusManutencaoEnum;
  equipamentos: EquipamentoRealizarManutencaoForm[];
}

export interface EquipamentoRealizarManutencaoForm {
  id: string;
  statusMotivo: string;
  nome: string;
  statusManutencaoId: string;
  dataManutencao?: string;
  arquivos: (
    | File
    | {
        id: string;
        referencia: string;
        mimetype: string;
        nome: string;
      }
  )[];
}

export interface ListarManutencaoQuery extends PaginateQuery {
  statusId?: StatusManutencaoEnum;
  dataInicio?: string;
  dataFim?: string;
  tenantsIds?: string[];
  emAtraso?: string;
}

export enum StatusManutencaoEnum {
  Pendente = "F104913A-1C46-4EBE-BFB3-F311EE9E0000",
  Concluida = "F104913A-1C46-4EBE-BFB3-F311EE9E0001",
  NaoRealizada = "F104913A-1C46-4EBE-BFB3-F311EE9E0002",
}

export interface HistoricoManutencaoLogs {
  data: string;
  title: string;
  message: string;
  arquivos: {
    id: string;
    nome: string;
    referencia: string;
    mimetype: string;
  }[];
  users: { id: string; nome: string };
}

export enum TipoIntervaloRepeticaoEnum {
  Diaria = "E104913A-1C46-4EBE-BFB3-F311EE9E0000",
  Semanal = "E104913A-1C46-4EBE-BFB3-F311EE9E0001",
  Mensal = "E104913A-1C46-4EBE-BFB3-F311EE9E0002",
  Anual = "E104913A-1C46-4EBE-BFB3-F311EE9E0003",
}
